export default __webpack_public_path__ + "b2eb70e2378f9d2089a638f0c044f3b0.png";